/*
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-02 11:17:21
 * @LastEditors: yd
 * @LastEditTime: 2020-07-11 16:48:21
 */
/*
* @params routes 菜单路由数组
*
*/
export const filterRouter = (routes) => {
  // 遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = routes.filter(route => {
    if (route.component) {
      route.component = _import(route.component)
    }
    if (route.children && route.children.length) {
      route.children = filterRouter(route.children)
    }
    return true
  })
  return accessedRouters
}
// 文件项目路径 
function _import (file) {
  return () => import('@/' + file)
}
/*
* @params title 为空的时候提示
* @params arr 新增的rule判断
*/
export const text_rules = (title, arr = [], len = 50) => {
  return [
    v => !!v || title,
    ...arr,
    v => String(v).length <= len || '超过输入个数',
    v => !/[@#$%^&()<>?/]/.test(v) || '请勿输入非法字符',
    v => !/^ +| +$/g.test(v) || '不能输入空格',
  ]
}
// 判断两个对象的key value 是否相等
export const isObjectValueEqual = (a, b) => {
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);

  if (aProps.length != bProps.length) {
    return false;
  }

  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];
    var propA = a[propName];
    var propB = b[propName];
    if (propA !== propB) {
      return false;
    }
  }
  return true;
}

